import { ViewModel } from '../view-model';

export interface DropdownDataType {
  key: string;
  value: string;
  title: string;
  [key: string]: string;
}

export class ErpDropdownOption implements ViewModel {
  readonly friendlyTypeNameSingular = 'ERP Dropdown Option';
  readonly apiRoute: string = null;
  dropdownTypeName: string;
  options: DropdownDataType[] = [];
  selectedItem: DropdownDataType;
  json(): any {
    return this;
  }
  loadFromJson(data: any): void {
    this.dropdownTypeName = data.dropdownTypeName;
    this.selectedItem = data.selectedItem;
    this.options = data.options;
  }
}
